import React from "react";
import { useHistory } from "react-router-dom";
import NotificationCardItem from "../NotificationCardItem/NotificationCardItem";
const LiveVehicleCount = ({ widgetData, slug, title, hasLink, route }) => {
  const history = useHistory();
  const handleRedirection = () => {
    if (hasLink) {
      history.push(route);
    }
  };
  return (
    <NotificationCardItem
      skin="trafficCounter"
      icon={"iconsminds-traffic-light"}
      title={title}
      slug={slug}
      widgetData={widgetData}
      handleRedirection={handleRedirection}
    />
  );
};

export default LiveVehicleCount;
